<template>
    <div>
        <CRow>
            <CCol>
                <div class="form-row  justify-content-end ">
                    <ejs-button style="margin-right: 10px; margin-top: 10px; margin-bottom: 10px;" cssClass="e-primary" v-on:click.native='syncData'>Sync Default Deadline Historical Data</ejs-button>
                </div>
                <ejs-grid ref='grid'
                          :dataSource='deadlineData'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :editSettings='editSettings'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='gridQuery'
                          :actionComplete="actionComplete"
                          :actionBegin="actionBegin">
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='contractTradeablePeriodId' headerText='ContractTradeablePeriod' :visible='false'></e-column>
                        <e-column field='tradablePeriod' headerText='Tradable Period' width=120 :allowEditing="false"></e-column>
                        <e-column field='deadlineDate' headerText='Deadline Date' :format='dateFormatOptions' type='date' :edit="dpParams" width=120 :validationRules="requiredRules"></e-column>
                    </e-columns>
                </ejs-grid>
                <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion'
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import { Query } from '@syncfusion/ej2-data'
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';


    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DatePickerPlugin);

    let datePickerObj, elem;
    export default {
        name: 'DefaultDeadlineForm',
        created() {
        },
        data() {
            return {
                deadlineData: SyncHelper.getDataManager("defaultdeadlinemechanism"),
                pageSettings: gridOptions.pageSettings,
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                maxDeadlineDate: null,
                editSettings: {
                    showConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.DefaultDeadlineMechanism.Update"],
                    mode: 'Normal'
                },
                toolbar: ['Edit', 'ExcelExport'],
                requiredRules: { required: true },
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                path: {
                    saveUrl: `${urls.apiBaseUrl}defaultdeadlineMechanism/import?contractId=${store.state.selectedContractId}`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                },
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {

                        datePickerObj = new DatePicker({
                            value: args.rowData[args.column.field] ? new Date(args.rowData[args.column.field]): null,
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //min: new Date(),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1,
                        });
                        datePickerObj.appendTo(elem);
                    }
                },
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "DefaultDeadline.xlsx", this.$refs);
            },
            fixDateOffset: function (date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return date;
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                if (args.requestType === 'beginEdit') {
                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadlineMechanism/${args.rowData.contractTradeablePeriodId}`).then(it => {

                        ///datePickerObj.min = new Date(it.data.lastFirstDay[0]);
                        datePickerObj.max = new Date(it.data.lastFirstDay[1]);

                    }).catch(
                        response => {
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                    );
                }
                if (args.requestType === 'save') {
                    if (datePickerObj.value) {
                        args.data.deadlineDate = this.fixDateOffset(datePickerObj.value);
                    }

                    if (datePickerObj.value != null) {
                        const timeElapsed = Date.now();
                        const today = new Date(timeElapsed);
                        today.toUTCString();
                        const dateValueWithoutTime = new Date(datePickerObj.value.getFullYear(), datePickerObj.value.getMonth(), datePickerObj.value.getDate());
                        const dateMaxWithoutTime = new Date(datePickerObj.max.getFullYear(), datePickerObj.max.getMonth(), datePickerObj.max.getDate());

                        //if (datePickerObj.value < datePickerObj.min) {
                        //    gridOptions.errorAlert("Date can not be smaller than first day of period.");
                        //    args.cancel = true;
                        //}
                        if (datePickerObj.value && args.data.tradablePeriod.includes("Q")) {

                            const selectedDate = dateValueWithoutTime;
                            const period = args.data.tradablePeriod;
                            if (selectedDate) {
                                const quarterYearPattern = /^Q(\d+)-(\d+)$/;
                                const match = quarterYearPattern.exec(period);
                                if (match) {
                                    const quarter = parseInt(match[1]);
                                    const year = parseInt("20" + match[2]);
                                    const quarterStartDate = new Date(year, (quarter - 1) * 3, 1);
                                    const previousQuarterStartDate = new Date(year, (quarter - 2) * 3, 1);
                                    if (selectedDate < quarterStartDate && selectedDate >= previousQuarterStartDate) {
                                        this.invalidDate = false;
                                    } else {
                                        gridOptions.errorAlert("The default date must be in the quarter preceding the delivery quarter.");
                                        args.cancel = true;
                                    }
                                }
                            }
                        }
                        if (datePickerObj.value && args.data.tradablePeriod.includes("CAL")) {
                            var selectedDate = dateValueWithoutTime;
                            var period = args.data.tradablePeriod;
                            if (selectedDate) {
                                var calendarYearPattern = /^CAL-(\d+)$/;
                                var match = calendarYearPattern.exec(period);

                                if (match) {
                                    var year = 2000 + parseInt(match[1].trim(), 10); 
                                    var previousYear = year - 1; 

                                    if (selectedDate.getFullYear() === previousYear) {
                                        this.invalidDate = false; 
                                    } else {
                                        gridOptions.errorAlert("The default date must be in the year preceding the delivery year.");
                                        args.cancel = true; 
                                    }
                                }
                            }
                        }
                        if (dateValueWithoutTime > dateMaxWithoutTime && !args.data.tradablePeriod.includes("Q") && !args.data.tradablePeriod.includes("CAL")) {
                            gridOptions.errorAlert("Date can not be bigger than first day of period.");
                            args.cancel = true;
                        }
                  

                    }
                }
            },
            actionComplete(args) {
                if (args.requestType === 'save') {
                    this.$refs.grid.refresh();
                }
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
            syncData: function () {
                apis.protectedApi.put(`defaultDeadlineMechanism/historicalMechanismTrigger?contractId=${store.state.selectedContractId}`, { contractid: store.state.selectedContractId }).then(response => {
                   gridOptions.infoAlert("Data sent to processing");
                }).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
        },
        computed: {
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>